import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { EstatusRequest, GetQuery, RecuperaUsuario, Usuario, UsuarioLineaAutomatizacionDto } from '../models/usuario';
import { environment } from 'src/environments/environment';
import { HttprService } from '../shared/httpr.service';
import { UsuarioWhatsApp } from '../models/whatsappApi/UsuarioWhatsapp';
import { FormGroup } from '@angular/forms';
import { CatalogoTabla } from '../models/catalogoTablas';

@Injectable({ providedIn: 'root' })
export class UsuariosService {
  usuarioLogeado: Usuario;

  constructor(private http: HttpClient, private httpr: HttprService) { }

  recuperaUsuariosV2(usuario = new Usuario()) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    let params = new HttpParams();
    params = params.append("IdEmpresa", usuario.idEmpresa.toString());
    params = params.append('IdEmpresaAfiliada', usuario.idEmpresaAfiliada.toString());
    params = params.append("IdUsuario", usuario.idUsuario.toString());
    params = params.append("IdProyecto", usuario.IdsProyecto.toString());
    params = params.append("IdRegion", usuario.idRegion.toString());
    params = params.append("Login", usuario.login.toString());
    params = params.append("Nombre", usuario.nombre.toString());
    params = params.append("PerfilSolicitado", usuario.tipo.toString());
    params = params.append("Estatus", usuario.estatus.toString());
    params = params.append("Pagina", usuario.Pagina.toString());
    params = params.append("CantidadReg", usuario.CantidadReg.toString());
    params = params.append("IdUsuarioUM", usuario.idUsuarioUM.toString());
    params = params.append("TipoRegistroSolicitado", usuario.tipoRegistro.toString());
    params = params.append("InvitarUsuario", usuario.invitarUsuario.toString());

    return this.http.get<Usuario>((url + "/users/recuperaUsuariosV2"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  recuperaDevicedWhatsapp(usuario: Usuario) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    let params = new HttpParams();
    params = params.append("web", "1");

    return this.http.get<Usuario>((url + "/users/recuperaDevicedWhatsappV2"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  eliminaDevicedWhatsap(usuario = new Usuario()) {
    return this.httpr.POST<Usuario>("/users/desconectar-DevicedWhatsapp", usuario);
  }

  guardaUsuario(usuario = new Usuario()) {
    return this.httpr.POST<Usuario>("/users/guardaUser", usuario);
  }

  recuperaMiembrosIntegrantes(usuario = new Usuario()) {
    return this.httpr.POST<Usuario>("/users/RecuperaIntegrantesEquiposMiembros", usuario);
  }

  recuperaVistas(vistas = new Usuario()) {
    return this.httpr.POST<Usuario>("/users/RecuperaVistas", vistas);
  }

  guardaAvatar(usuario = new Usuario()) {
    var url = environment.apiUrl;
    const formData: any = new FormData();
    formData.append('files', usuario.avatarFile)
    formData.append('IdUsuario', usuario.idUsuario);

    return this.http.post<Usuario>(url + "/users/actualizaAvatarWeb/", formData);
  }

  recuperaDevicedWhatsappGrupo(usuario = new Usuario()) {
    return this.httpr.POST<UsuarioWhatsApp[]>("/whatsapp/recupera-usuario-grupo", usuario);
  }

  recuperaTelefonoGrupo(usuario = new UsuarioWhatsApp()) {
    return this.httpr.POST<UsuarioWhatsApp[]>("/whatsapp/recupera-telefono-grupo", usuario);
  }

  async guardaUsuarioPendiente(form: FormGroup) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;

    formData.append('Nombre', form.value.nombre);
    formData.append('Login', form.value.correo);
    formData.append('Telefono', form.value.telefono.number);
    formData.append('Lada', form.value.telefono.dialCode);
    formData.append('IdProyecto', -1);
    formData.append('IdEmpresaAfiliada', form.value.idEmpresaAfiliada);


    return this.http.post<Usuario>(url + "/users/guarda-usuario-pendiente", formData, { headers }).pipe(map((data: Usuario) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  async recuperaUsuarioPendiente(idProyecto: number) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;

    formData.append('IdProyecto', idProyecto);

    return this.http.post<Usuario>(url + "/users/recupera-usuario-pendiente", formData, { headers }).pipe(map((data: Usuario) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  eliminaCuentaMiembro(usuario = new Usuario()) {
    return this.httpr.POST<Usuario[]>("/users/elimina-cuenta", usuario);
  }

  inhabilitarCuentaMiembro(usuario = new Usuario()) {
    return this.httpr.POST<Usuario[]>("/users/inhabilitar-cuenta", usuario);
  }

  recuperaUsuarioInfoV2(usuario = new Usuario()) {
    var params = new HttpParams();
    params = params.append("IdUsuario", usuario.idUsuario.toString());
    params = params.append("IdEmpresaAfiliada", usuario.idEmpresaAfiliada.toString());
    params = params.append("IdRegion", usuario.idRegion.toString());
    params = params.append("IdUsuarioUM", usuario.idUsuario.toString());


    return this.httpr.GET<Usuario>("/users/recuperaUsuarioInfoV2", params);
  }

  recuperaUsuarioClasificacion(usuario = new GetQuery()) {
    var params = new HttpParams();
    params = params.append("tipoRegistro", usuario.tipoRegistro);

    return this.httpr.GET<CatalogoTabla[]>("/users/obtener-tipo-caracterizacion-perfil", params);
  }

  recuperarTourProyecto(idUsuario: number) {
    let params = new HttpParams();

    params = params.append('IdUsuario', idUsuario.toString());

    return this.httpr.GET<RecuperaUsuario>("/users/Recupera-Estatus_tutorial", params);
  }

  terminaTourProyecto(estatusRequest: EstatusRequest) {
    let params = new HttpParams();

    params = params.append('IdUsuario', estatusRequest.idUsuario.toString());
    params = params.append('IdModulo', estatusRequest.idModulo.toString());
    params = params.append('IdEstatus', estatusRequest.idEstatus.toString());

    return this.httpr.GET<EstatusRequest>("/users/Edita-Estatus_tutorial", params);
  }

  recuperaInfoUsuarioV2(usuario = new Usuario()) {
    let params = new HttpParams();

    params = params.append('IdEmpresaAfiliada', usuario.idEmpresaAfiliada.toString());
    params = params.append('IdUsuario', usuario.idUsuario.toString());
    params = params.append('Tipo', "");
    params = params.append('IdUsuarioUM', usuario.idUsuarioUM.toString());
    params = params.append('IdRegion', "-1");

    return this.httpr.GET<RecuperaUsuario>("/users/recuperaUsuarioInfoV2", params)
      .pipe(
        map(response => ({
          idUsuario: response[0].idUsuario,
          nombre: response[0].nombre,
          primerosPasosListos: response[0].primerosPasosListos,
        }))
      );
  }

  recuperaUsuariosEmpresaAfiliada(usuario = new Usuario()) {
    let params = new HttpParams();

    params = params.append('IdEmpresaAfiliada', usuario.idEmpresaAfiliada.toString());

    return this.httpr.GET<any>("/EmpresasAfiliadas/filtroEmpresaAfiliadaUsuario", params);
  }

  removerUsuarioSuscripcion(usuario = new Usuario()) {
    return this.httpr.POST<Usuario>("/users/remover-usuario-suscripcion", usuario);
  }

  async checkDominioExistence(dominio: string): Promise<any> {
    const params = new HttpParams().set('dominio', dominio);

    try {
      return await this.httpr.GET<any>("/users/valida-dominio-tienda", params).toPromise();
    } catch (error) {
      console.error("Error al validar dominio:", error);
      throw error;
    }
  }

  guardaUsuarioAutomatizacionLinea(usuarioLineaDto: UsuarioLineaAutomatizacionDto) {
    return this.httpr.POST<any>("/users/guarda-usuario-automatizacion-linea", usuarioLineaDto);
  }

  recuperaUsuariosLineaAutomatizacion(idLinea: number = 0, idAutomatizacion: number = 0) {
    let params = new HttpParams();
    params = params.append('IdLinea', idLinea.toString());
    params = params.append('IdAutomatizacion', idAutomatizacion.toString());

    return this.httpr.GET<any>("/users/recupera-usuarios-linea-automatizacion", params);
  }

  desactivarUsuario(usuario = new Usuario()) {
    return this.httpr.POST<Usuario>("/users/desactivar-usuario", usuario);
  }
}
